import React from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import styled from "styled-components";
import { MODAL_STYLES } from "../../constants";

const ModalHeader = styled.div`
  background: var(--clr-red-dark);
  color: white;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  font-size: 1em;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1.4em;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  opacity: 0.8;
  transition: opacity 0.15s;

  &:hover {
    opacity: 1;
  }
`;

const ModalBody = styled.div`
  padding: 16px 20px 20px;
  max-height: 400px;
  overflow-y: auto;
`;

const ErrorCard = styled.div`
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-left: 4px solid var(--clr-red-dark);
  border-radius: 6px;
  padding: 12px 14px;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const BoxLabel = styled.div`
  font-size: 0.8em;
  font-weight: 600;
  color: #991b1b;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 6px;
`;

const ErrorItem = styled.div`
  font-size: 0.9em;
  font-weight: 600;
  color: #7f1d1d;
  padding: 2px 0;
`;

const FooterBar = styled.div`
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
`;

const CloseBtn = styled.button`
  background: white;
  color: #555;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 20px;
  font-size: 0.85em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: #f3f4f6;
    border-color: #999;
    color: #333;
  }
`;

/**
 * Modal component for displaying update errors
 */
const ErrorModal = React.memo(({ isOpen, onClose, errors }) => {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <ReactModal
      isOpen={isOpen}
      style={MODAL_STYLES}
      onRequestClose={onClose}
      appElement={document.getElementById("root")}
    >
      <ModalHeader>
        Update Errors
        <CloseButton onClick={onClose}>&times;</CloseButton>
      </ModalHeader>
      <ModalBody>
        {errors.map((error) => (
          <ErrorCard key={`${error.blockError}-${error.boxNumber}`}>
            <BoxLabel>Box {error.boxNumber}</BoxLabel>
            <ErrorItem>{error.blockError}</ErrorItem>
          </ErrorCard>
        ))}
      </ModalBody>
      <FooterBar>
        <CloseBtn onClick={onClose}>Close</CloseBtn>
      </FooterBar>
    </ReactModal>
  );
});

ErrorModal.displayName = "ErrorModal";

ErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      blockError: PropTypes.string.isRequired,
      boxNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    })
  ).isRequired,
};

export default ErrorModal;
